import { LucideWifi, QrCode } from 'lucide-react';
import { CSSProperties } from 'react';

interface OfflineServerSectionProps {
  styles: Record<string, CSSProperties>;
  onConnect: () => void;
}

export const OfflineServerSection = ({ styles, onConnect }: OfflineServerSectionProps) => (
  <div style={styles.upgradeSection}>
    <div style={styles.upgradeTitle}>
      <LucideWifi size={20} />
      Send Messages Offline
    </div>
    <div style={{ ...styles.featureList, color: '#166534' }}>
      <div style={styles.featureItem}>
        <svg style={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
        Messages sent even when browser is closed
      </div>
      <div style={styles.featureItem}>
        <svg style={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
        More reliable delivery
      </div>
      <div style={styles.featureItem}>
        <svg style={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
        Premium feature
      </div>
    </div>
    <button
      style={styles.upgradeButton}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onConnect();
      }}
      data-action-button="true"
    >
      <QrCode size={20} />
      Connect Offline Server
    </button>
  </div>
); 